export const ORG_HOME_DRAWER_WIDTH = 250;
